import { AxiosResponse } from "axios";
import BaseAPI from "../api";

const path: string = "menu";

export type menuState = {
    menu_name: string;
    menu_link: string;
    menu_status_open: string;
    id_menu_ref: number | null;
    group_menu:string | null;
    is_not_show:boolean;
}


export class MenuApi extends BaseAPI {
    static getMenuTree(query: { keyword?: string, }): Promise<AxiosResponse> {
        return this.api.get(`${path}/tree`, { params: { ...query } })
    }
    static getDetailMenu(id_menu: number): Promise<AxiosResponse> {
        return this.api.get(`${path}/${id_menu}/get-menu-detail`)
    }
    static update(id_menu: number, body: menuState): Promise<AxiosResponse> {
        return this.api.patch(`${path}/${id_menu}`, body)
    }
    static delete(id_menu: number): Promise<AxiosResponse> {
        return this.api.delete(`${path}/${id_menu}`)
    }
    static createdMenu(body: menuState): Promise<AxiosResponse> {
        return this.api.post(`${path}`, body)
    }
}